<template>
  <g>
    <path
      d="M12 15.0002C13.6569 15.0002 15 13.6571 15 12.0002C15 10.3434 13.6569 9.00024 12 9.00024C10.3431 9.00024 9 10.3434 9 12.0002C9 13.6571 10.3431 15.0002 12 15.0002Z"
    />
    <path
      d="M20 4.00024H16.83L15.59 2.65024C15.22 2.24024 14.68 2.00024 14.12 2.00024H9.88C9.32 2.00024 8.78 2.24024 8.4 2.65024L7.17 4.00024H4C2.9 4.00024 2 4.90024 2 6.00024V18.0002C2 19.1002 2.9 20.0002 4 20.0002H20C21.1 20.0002 22 19.1002 22 18.0002V6.00024C22 4.90024 21.1 4.00024 20 4.00024ZM12 17.0002C9.24 17.0002 7 14.7602 7 12.0002C7 9.24024 9.24 7.00024 12 7.00024C14.76 7.00024 17 9.24024 17 12.0002C17 14.7602 14.76 17.0002 12 17.0002Z"
    />
  </g>
</template>
